import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { UserService } from '../../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class ActiveUserGuard  {
  constructor(
    private readonly userService: UserService,
    private readonly router: Router,
    private readonly msalGuard: MsalGuard
  ) { }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    //if the user does not have an org assignment, the user is forced back to the main page where they will be shown an error
    //if the user is an admin, they will have all org assignments by default, circumventing this intentionally.
    const msalResult = await this.msalGuard.canActivate(route, state).toPromise();
    if (msalResult === true) {
      const user = await this.userService.currentUser.toPromise();
      if (user.organizations.length === 0 || !user.active) {
        this.router.navigate(['/']);
      }
      return true;
    }
    else {
      return msalResult;
    }
  }
}
